import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AuthPage.css';

const AuthPage = () => {
  const location = useLocation();
  // State to track if we're in the "Sign In" view or "Sign Up" view.
  // We set the initial state based on the URL path.
  const [isLoginView, setIsLoginView] = useState(location.pathname === '/signin');

  // This effect ensures that if the user navigates between /signin and /signup
  // using browser buttons, the component updates its view correctly.
  useEffect(() => {
    setIsLoginView(location.pathname === '/signin');
  }, [location.pathname]);

  const toggleView = () => {
    setIsLoginView(!isLoginView);
  };

  return (
    <div className="auth-container">
      <div className="auth-content">
        {/* The title changes based on the current view */}
        <h1>Sign In/Up</h1>

        {/* Conditional placeholder text */}
        {isLoginView ? (
          <>
            <p>User accounts and full sign-in functionality are coming soon!</p>
            <p>This feature will allow you to view your order history and save your shipping information and more!</p>
          </>
        ) : (
          <>
            <p>We're currently working on building our user account system. Check back soon to create your account!</p>
          </>
        )}

        {/* Toggle button to switch between views */}
        <div className="auth-toggle">
          
      
        </div>
        
        <Link to="/" className="auth-link">
          ← Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default AuthPage;